"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var Term = function (_a) {
    var title = _a.title, children = _a.children;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setOpen = _b[1];
    var handleClick = function () { return setOpen(!isOpen); };
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.term, "  ").concat(isOpen ? styles_module_scss_1.default.open : ''), onClick: handleClick },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.termTitle) },
            react_1.default.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { d: "M8.52246 0H7.52246V7.5H0.0224609V8.5H7.52246V16H8.52246V8.5H16.0225V7.5H8.52246V0Z", fill: "currentColor" })),
            react_1.default.createElement("div", null, title)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.termText }, children)));
};
var Terms = function (_a) {
    var htmlContent = _a.htmlContent;
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var faq = (0, react_1.useMemo)(function () { return (0, apps_shared_1.parseFAQ)(htmlContent); }, [htmlContent]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('loyaltyTermsTitle')),
        faq.map(function (item, idx) { return (react_1.default.createElement(Term, { title: item === null || item === void 0 ? void 0 : item.question, key: "faq_item".concat(idx) },
            react_1.default.createElement("div", null, (0, react_html_parser_1.default)((0, apps_shared_1.replaceAmountTemplate)(item === null || item === void 0 ? void 0 : item.answer, currentCurrency))))); })));
};
exports.default = Terms;
